import React, { useEffect, useRef } from "react";
import SearchResultItem from "./SearchResultItem";

interface SearchResultListProps {
  results: { id: number; name: string; route: string; moduleCode: string }[]; // 👈 agregado `moduleCode`
  onClose: () => void;
}

/**
 * 📜 SearchResultList (con autocierre y sincronización de módulo)
 *
 * - Muestra los resultados del buscador.
 * - Cierra automáticamente al hacer clic fuera.
 * - Pasa `moduleCode` a cada ítem para sincronizar el módulo activo.
 */
const SearchResultList: React.FC<SearchResultListProps> = ({ results, onClose }) => {
  const listRef = useRef<HTMLUListElement>(null);

  // 👀 Cerrar al hacer clic fuera del panel
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (listRef.current && !listRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <ul
      ref={listRef}
      className="
        absolute left-0 top-full z-50 mt-2 w-full max-h-72 overflow-y-auto
        rounded-2xl border border-stroke bg-white text-black
        dark:border-strokedark dark:bg-boxdark dark:text-whiten
        shadow-lg ring-1 ring-black/5 backdrop-blur-sm
        transition-all duration-200 animate-fadeIn
      "
    >
      {results.length > 0 ? (
        results.map((item) => (
          <SearchResultItem
            key={item.id}
            name={item.name}
            route={item.route}
            moduleCode={item.moduleCode}
            onClose={onClose}
          />
        ))
      ) : (
        <li className="px-5 py-3 text-sm text-gray-500 dark:text-gray-400 text-center">
          Sin resultados encontrados
        </li>
      )}
    </ul>
  );
};

export default SearchResultList;
